<template lang="pug">
  feature-avatar(
    :size="100"
    v-shared-element:[heroIdProfileAvatar]
    :src="src"
    :lazy-src="srcLazy")
</template>

<script>
import { computed } from '@vue/composition-api'
import { routeCurrent } from '@iez/core/router/'
import { injectRouteState } from '@iez/core'

export default {
  setup () {
    const routeState = injectRouteState()

    return {
      routeState,
      src: computed(() => routeState.user?.image?.src),
      srcLazy: computed(() => routeState.user?.image?.srcLazy),
      heroIdProfileAvatar: computed(() => routeCurrent.query?.heroIdProfileAvatar),
      routeCurrent
    }
  }
}
</script>
